import { IUser } from 'app/shared/model/user.model';

export interface ISurveillantGeneral {
  id?: string;
  firstName?: string;
  lastName?: string;
  telephone?: number;
  authorities?: any[];
  login?: string;
  email?: string;
  activated?: boolean;
  ecoleId?: string;
  user?: IUser | null;
}

export const defaultVal: Readonly<ISurveillantGeneral> = {
  id: null,
  firstName: '',
  lastName: '',
  telephone: null,
  authorities: [],
  login: '',
  email: '',
  activated: true,
  ecoleId: '',
  user: null,
};
